/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { WfespPluginConf } from "./WfespPluginConf";
import * as t from "io-ts";

// required attributes
const WfespPluginConfsR = t.interface({
  wfesp_plugin_confs: t.readonlyArray(
    WfespPluginConf,
    "array of WfespPluginConf"
  )
});

// optional attributes
const WfespPluginConfsO = t.partial({});

export const WfespPluginConfs = t.intersection(
  [WfespPluginConfsR, WfespPluginConfsO],
  "WfespPluginConfs"
);

export type WfespPluginConfs = t.TypeOf<typeof WfespPluginConfs>;
